import axios from '../../config/axios.js'
import store from '../../vuex/store.js'

const STATE = {
    username: null,
}

const GETTERS = {
    username: state => state.username,
}

const MUTATIONS = {
    getUsername(state, username) {
        state.username = username
    },
}

const ACTIONS = {

    async confirmEmail({ commit }, payload) {
        await axios.CONFIRM.get('/api/user/confirm/' + payload.token)
            .then(res => {
                // console.log('confirm/confirmEmail', res)
                if (res.data.result) {
                    store.commit('auth/setAccessToken', res.data.access_token)
                    store.commit('auth/storeAccessToken', res.data.access_token)
                } else {
                    throw new Error(res.data)
                }
            })
    },

    async requestConfirmEmail({ commit }, payload) {
        await axios.CONFIRM.post('/api/user/confirmrequest', {
                recipients: [payload.recipient]
            })
            .then(res => {
                // console.log('confirm/requestConfirmEmail', res)
                if (!res.data.result) {
                    throw new Error(res.data)
                }
            })
    },

    async requestResetPassword({ commit }, payload) {
        await axios.GENERAL.post('/api/user/password', {
                email: payload.email
            })
            .then(res => {
                // console.log('confirm/requestResetPassword', res)
                if (!res.data.result) {
                    throw new Error(res.data)
                }
            })
    },

    async checkResetPasswordToken({ commit }, payload) {
        await axios.GENERAL.get('/api/user/password/' + payload.token)
            .then(res => {
                // console.log('confirm/checkResetPasswordToken', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async findUsername({ commit }, payload) {
        await axios.GENERAL.post('/api/user/username', payload)
            .then(res => {
                if (res.data.result) {
                    commit('getUsername', res.data.username)
                } else {}
            })
    },
}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/confirm.js